export default __webpack_public_path__ + "static/media/Viamo.d72d5d32.jpg";